/**
 * Ex:
 *   10000 -> 10 000
 *   20000000 -> 20 000 000
 */
function formatLargeNumber(value: number): string {
    function reverseString(input: string): string {
        return input
            .split('')
            .reverse()
            .join('')
    }

    const valueStr = value.toString()
    const reversedValueStr = reverseString(valueStr)
    const reversedValueWithSpaces = reversedValueStr.replace(/(\d{3})/g, '$1 ')
    const finalValue = reverseString(reversedValueWithSpaces)
    return finalValue
}

export { formatLargeNumber }
